export default __webpack_public_path__ + "static/media/pregnancy_guide.366c737c.png";